import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import objectPath from 'object-path';

import {GridContainer, GridCell} from '../../../../../components/grid';
import {paletteData, Button, Typography, Dialog,  Input } from '../../../../../components/styles';
import {LayoutEdit} from '../../../../../components/layout';

import HeaderForm from '../../../../../components/forms/header';

function EditCategoryLayoutSubPanel({
  me,
  focusedCategory,
  handleChangeFocusedCategory,
  processing,
  setProcessing
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(undefined);
  const [imageLibrary, setImages] = useState(undefined);
  const [page ] = useState(0);

  useEffect(() => {
    if(!imageLibrary) {
      const gallery = focusedCategory.gallery;
      setImages(gallery);
    }
  }, [focusedCategory, imageLibrary]);

  const changePage = (page, type, index, path, value) => {
    if(type === 'insert') {
      const tempLayout = focusedCategory.layout || {
        header: {},
        multiPageEnabled: false,
        pages: [{
          title: 'home',
          sections: [],
        }],
      };
      if(!tempLayout.pages) {
        tempLayout.pages = [{
          title: 'home',
          sections: [],
        }];
      };
      tempLayout.pages[page].sections.splice(index, 0, value);
      handleChangeFocusedCategory('layout', tempLayout);
    } else if (type === 'update') {
      const tempLayout = focusedCategory.layout;
      if(path === undefined) {
        tempLayout.pages[page].sections = value;
      } else {
        if(path === '') {
          objectPath.set(tempLayout.pages[page].sections, `${index}`, value);
        } else {
          objectPath.set(tempLayout.pages[page].sections, `${index}.${path}`, value);
        }
      }
      handleChangeFocusedCategory('layout', tempLayout);
    }
  }

  const changeParent = (type, path, value) => {
    if(type === 'insert') {
      const tempArray = objectPath.get(focusedCategory, path) || [];
      tempArray.push(value);
      objectPath.set(focusedCategory, path, tempArray);
    }
  }

  return (
    <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
      <div style={{background: paletteData.primary.standard.background, padding: 10}}>
        <GridContainer>
          <GridCell center={true}>
            <a
              href={`https://rerengatahi.nz/category/${focusedCategory._id}`}
              style={{textDecoration: 'none'}}
              target="_blank"
              rel='noopener noreferrer'
            >
              <Typography style={{color: paletteData.primary.standard.foreground}}>
                Layout
              </Typography>
            </a>
          </GridCell>
          <GridCell center={true}>
            <a
              href={`https://rerengatahi.nz/category/${focusedCategory._id}`}
              style={{textDecoration: 'none'}}
              target="_blank"
              rel='noopener noreferrer'
            >
              <span className="material-icons md-24" style={{color: paletteData.primary.standard.foreground, marginLeft: 5}}>visibility</span>
            </a>
          </GridCell>
          <GridCell weight={1}/>
        </GridContainer>
      </div>

      <LayoutEdit
        imageLibrary={imageLibrary}
        videoLibrary={focusedCategory?.videoLibrary || []}
        sections={(focusedCategory?.layout?.pages && focusedCategory?.layout?.pages[page]?.sections) || []}
        changeSection={(type, index, path, value) => changePage(page, type, index, path, value)}
        changeParent={(type, path, value) => changeParent(type, path, value)}
      />

      {/*popouts and popups*/}
      {dialogOpen &&
        <Dialog
          open={dialogOpen}
          handleClose={() => {
           setDialogData(undefined);
           setDialogOpen(false);
         }}
        >
          <div style={{padding: 10, textAlign: 'center', background: paletteData.primary.standard.background}}>
            <Typography size='title' style={{color: paletteData.primary.standard.foreground}}>
              {dialogData?.title}
            </Typography>
          </div>
          {(dialogData?.message) &&
            <div style={{padding: 10}}>
              <Typography>
                {dialogData.message}
              </Typography>
            </div>
          }
          {dialogData?.type === 'editHeader' &&
            <div style={{padding: 10}}>
              <HeaderForm
                header={dialogData?.value || {}}
                handleChange={(name, value) => {
                  setDialogData({
                    ...dialogData,
                    value: {
                      ...dialogData.value,
                      [name]: value,
                    },
                  });
                }}
                processing={processing}
              />
            </div>
          }
          {dialogData?.type === 'movePage' &&
            <div style={{padding: 10}}>
              <Input
                type='number'
                label='New Index'
                value={dialogData?.value?.index}
                onChange={(value) => {
                  setDialogData({
                    ...dialogData,
                    value: {
                      ...(dialogData.value || {}),
                      index: value - 1,
                      humanIndex: value,
                    }
                  });
                }}
              />
            </div>
          }
          <GridContainer>
            <GridCell weight={1}/>
            <GridCell style={{padding: 10}}>
              <Button
                palette='primary'
                 onClick={() => {
                  setDialogData(undefined);
                  setDialogOpen(false);
                }}
              >
                {dialogData?.type === 'message' ? 'OK' : 'Cancel'}
              </Button>
            </GridCell>
            {dialogData?.type === 'editHeader' &&
              <GridCell style={{padding: 10}}>
                <Button
                  palette='primary'
                   onClick={() => {
                     const tempLayout = {
                       ...focusedCategory.layout,
                       header: dialogData?.value,
                     };
                     handleChangeFocusedCategory('layout', tempLayout);
                     setDialogData(undefined);
                     setDialogOpen(false);
                  }}
                >
                  Edit Header
                </Button>
              </GridCell>
            }
            {dialogData?.type === 'messageWithCallback' &&
              <GridCell style={{padding: 10}}>
                <Button
                  palette='primary'
                   onClick={() => {
                     dialogData?.data?.callback();
                     setDialogData(undefined);
                     setDialogOpen(false);
                  }}
                >
                  Submit
                </Button>
              </GridCell>
            }
          </GridContainer>
        </Dialog>
      }
    </div>
  );
};

EditCategoryLayoutSubPanel.propTypes = {
  me: PropTypes.shape({}),
  focusedCategory: PropTypes.shape({}),
  handleChangeFocusedCategory: PropTypes.func,
  processing: PropTypes.bool,
  setProcessing: PropTypes.func,
};

export default EditCategoryLayoutSubPanel;
